
import { Helmet, HelmetProvider } from 'react-helmet-async';
import ClientsSection from "../components/ClientsSection"
import ClientsHeroSection from "../components/ClientsComponents/ClientsHeroSection"
import FeaturedCaseStudy from '../components/ClientsComponents/FeaturedStudyText';
import FreeTextSection from '../components/ClientsComponents/FreeSection';
import TestimonialCarousel from '../components/TestimonialSlider'

const Clients = () => {
  return (
    <>
      <HelmetProvider>
      <Helmet>
        <title>Clients | Brand Acumen</title>
        <meta name="description" content="See some of the amazing clients we've worked with at Brand Acumen." />
        <meta name="description" content="Welcome to the homepage of Brand Acumen." />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Home | Brand Acumen" />
        <meta property="og:description" content="Welcome to the homepage of Brand Acumen." />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:url" content="https://brandacumen.co/" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:title" content="Home | Brand Acumen" />
        <meta name="twitter:description" content="Welcome to the homepage of Brand Acumen." />
        <meta name="twitter:image" content="/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
      <ClientsHeroSection />
      <ClientsSection />
      <TestimonialCarousel />
      <FreeTextSection />
      <FeaturedCaseStudy />
      </HelmetProvider>

    </>
  );
};

export default Clients;
